<template>
  <b-modal
    id="businesses-tag-modal"
    :title="tag ? 'Update tag': 'Create new tag'"
    hide-footer
    size="lg"
    @hidden="$emit('hidden')"
  >
    <TagsForm
      :tag="tag"
      @refetch="$emit('refetch')"
    />
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import TagsForm from './TagsForm.vue'

export default {
  components: { BModal, TagsForm },
  props: {
    tag: {
      type: Object,
      default: undefined,
    },
  },
}
</script>
